var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"blog"}},[_c('Header'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"container-general"}},[_c('section',{staticClass:"blog-banner"},[_c('div',{staticClass:"blog-bg"},[_c('h2',[_vm._v("BLOG")])])]),_c('section',{staticClass:"blog-posts"},[_c('h2',[_vm._v("Blog Posts Coming Soon!")])])])
}]

export { render, staticRenderFns }